/**
 * 购买链接配置
 * 从环境变量读取购买链接，用于CN区域的激活码购买
 */

// 通用购买链接（用于个人账户激活码）
export const PURCHASE_URL = 
  (import.meta as { env?: { VITE_PURCHASE_URL?: string } }).env?.VITE_PURCHASE_URL || 
  'https://www.xiaohongshu.com';

// 团队激活码购买链接（可与通用链接不同）
export const TEAM_PURCHASE_URL = 
  (import.meta as { env?: { VITE_TEAM_PURCHASE_URL?: string } }).env?.VITE_TEAM_PURCHASE_URL || 
  PURCHASE_URL; // 默认使用通用链接

/**
 * 获取个人账户激活码购买链接
 */
export function getPurchaseUrl(): string {
  return PURCHASE_URL;
}

/**
 * 获取团队激活码购买链接
 * 用于团队创建升级提示
 */
export function getTeamPurchaseUrl(): string {
  return TEAM_PURCHASE_URL;
}
